<template>
	<div
		class="horizontal-decor-divider-faded"
		:class="[
			`horizontal-decor-divider-faded-${direction}`,
			{ 'dark-theme': isDark },
		]"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 297.8 19.8"
			preserveAspectRatio="none"
		>
			<defs>
				<linearGradient
					id="divider-faded-gradient"
					x1="17.8"
					y1="9.9"
					x2="297.8"
					y2="9.9"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stop-color="#f4d278" />
					<stop offset=".5" stop-color="#f4d278" />
					<stop offset="1" stop-color="#f4d278" stop-opacity="0" />
				</linearGradient>
			</defs>
			<g id="Layer_58">
				<rect class="cls-2" x="17.8" y="7.9" width="280" height="4" />
			</g>
			<g id="Layer_59">
				<path
					class="cls-1"
					d="M9.9,0L0,9.9l9.9,9.9,7.9-7.9v-4L9.9,0ZM9.9,14.14l-4.24-4.24,4.24-4.24,4.25,4.24-4.25,4.24Z"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts" setup>
interface Props {
	direction?: "left" | "right";
	isDark?: boolean;
}
const { direction = "left", isDark = false } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.horizontal-decor-divider-faded {
	display: flex;
	position: relative;
	z-index: 0;
	width: 100%;

	svg {
		width: 100%;
	}

	&-right {
		transform: rotate(180deg);
	}

	.cls-1 {
		fill: #f4d278;
	}
	.cls-2 {
		fill: url(#divider-faded-gradient);
	}
	&.dark-theme {
		.cls-1 {
			fill: rgba($color: #372615, $alpha: 0.5);
		}
		.cls-2 {
			fill: rgba($color: #372615, $alpha: 0.5);
		}
	}
}
</style>
